import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-attendance',
  templateUrl: './add-attendance.component.html',
  styleUrls: ['./add-attendance.component.scss']
})
export class AddAttendanceComponent implements OnInit {
  modalForm: FormGroup;
  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.modalForm = this.fb.group({
      stu_feedback: ['', Validators.required],
      private_feedback: ['']
    });
  }
  submit() {
    this.activeModal.close(this.modalForm.value);  }
    cancel() {
      // Dismiss the modal without sending data
      this.activeModal.dismiss('cancel');
    }
}
